import styled from 'styled-components';

export const OnboardingApplicationDetails = styled.div`
  margin-top: 30px;
`;

export const Tasks = styled.div`
  margin-top: 14px;
  width: 100%;
`;

export const VerifySsn = styled.div`
  margin-top: 20px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${(p) => p.theme.textColor};
  padding: 20px;
  background-color: #fff;

  > div:nth-child(1) {
    line-height: 24px;
    margin-bottom: 10px;
  }

  span {
    font-weight: bold;
  }
`;

export const File = styled.div`
  background-color: rgba(61, 64, 102, 0.05);
  border-radius: 0.25rem;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  opacity: 0.8;
  :hover {
    opacity: 1;
  }
`;

export const RepeatingContainer = styled.div`
  padding: 0.75rem;
  border: 0.0625rem solid ${(p) => p.theme.colors.purpleTrans10};
  border-radius: 0.25rem;
  margin-top: 10px;
  > div:not(:first-child) {
    margin-top: 10px;
  }
`;
